import NationalExecutiveCommittee from "../NationalExecutiveCommittee";
import PoliticalDocuments from "../PoliticalDocuments";
import PoliticalPartyAgent from "../PoliticalPartyAgent";
import PoliticalPartyInfo from "../PoliticalPartyInfo";
import RegistredAndNonRegistered from "../RegistredAndNonRegistered";

export default function () {
	return (
		<>
			<div className="card">
				<PoliticalPartyAgent header={"Agents"} />
			</div>
		</>
	);
}
